import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { Button, message, Input, Form, Checkbox } from "antd/lib";
import { useDispatch, useSelector } from "react-redux";
import { GetPosp, PospSavePass } from "../../Redux/actions/NumBikeation";
import logo from "../../images/logo-vibe.png";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import axiosInPosp from "../../Redux/axios/AxiosInPosp";
import { ONBDetils } from "../../Redux/actions/OnboardAction";
function PospLogin({ setIsModalOpen, setShowPassword }) {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const RemPass = useSelector((state) => state?.pass);
  const [LogDetail, setLogDetail] = useState(RemPass);
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [iserror, setiserror] = useState(false);
  const [loading, setloading] = useState(false);
  const [rememberPassword, setRememberPassword] = useState(false);
  const [BaseUrl, setBaseURL] = useState("");

  const history = useHistory();
  useEffect(() => {
    const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
    setBaseURL(BASEURL);
  }, [BaseUrl]);
  useEffect(() => {
    //setRememberPassword(true);
    setemail(LogDetail?.rememberedEmail);
    setpassword(LogDetail?.rememberedPassword);
    form.setFieldsValue({
      email: LogDetail?.rememberedEmail,
      password: LogDetail?.rememberedPassword,
    });
  }, [LogDetail]);

  const handleSubmit = () => {
    if (email && password) {
      setiserror(false);
      setloading(true);
      axios
        .post(`${BaseUrl}v1/posp/login`, { email: email, password: password })
        .then((res) => {
          console.log(res);
          const PData = res?.data;
          setloading(false);
          console.log(PData);
          const NewArray = [];
          NewArray.push(PData);
          console.log(NewArray);
          const updatedData = NewArray?.map((item) => ({
            ...item,
            isPOSP: true,
          }));
          console.log(updatedData);
          dispatch(GetPosp(updatedData[0]));
          axiosInPosp
            .get("v1/posp/profile/edit")
            .then((res) => {
              console.log(res);
              const SData = res?.data?.profile;
              dispatch(ONBDetils(SData));
            })
            .catch((err) => {
              console.log(err);
            });
          setIsModalOpen(false);
          message.success("Login Successfully");
          history.push("/");
        })
        .catch((err) => {
          // console.log(err?.response);
          setloading(false);
          message.error(err?.response?.data?.message);
        });
    } else {
      setiserror(true);
    }
    if (rememberPassword) {
      dispatch(
        PospSavePass({
          Email: email,
          Password: password,
        })
      );
    } else {
      dispatch(
        PospSavePass({
          Email: "",
          Password: "",
        })
      );
    }
  };
  const forgetClick = () => {
    setShowPassword(true);
  };
  return (
    <div className="logn-body-rn">
      <div className="login-cont-r">
        {/* <div className="login-img-div">
          <img
            className="login-img-i-r imgh"
            src={logo}
            alt=""
          />
        </div> */}
        <div className="login-inpt-div">
          <div className="d-block text-center my-2">
            <h4 className="mb-2">Please Login to continue</h4>
          </div>
          <div className="inpt-number-din-r">
            <div className="mb-2">
              <Form
                onFinish={handleSubmit}
                form={form}
                requiredMark={false}
                layout="vertical"
              >
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Email",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    // prefix={<UserOutlined />}
                    onChange={(e) => {
                      setemail(e.target.value);
                    }}
                    placeholder="Enter Email"
                  />
                </Form.Item>
                <Form.Item
                  name="password"
                  label="Enter Password"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Password",
                    },
                  ]}
                >
                  <Input.Password
                    size="large"
                    // prefix={<UserOutlined />}
                    onChange={(e) => {
                      setpassword(e.target.value);
                    }}
                    placeholder="Enter Password"
                    iconRender={(visible) =>
                      visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                    }
                  />
                </Form.Item>
                <Form.Item className="mb-0">
                  <Checkbox
                    checked={rememberPassword}
                    onChange={(e) => setRememberPassword(e.target.checked)}
                  >
                    Remember Password
                  </Checkbox>
                </Form.Item>
                <Form.Item className="mb-2">
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                      width: "100%",
                      background: "#293890",
                      border: "#293890",
                      marginTop: "3%",
                      maxHeight: "42px",
                      minHeight: "42px",
                    }}
                    loading={loading}
                  >
                    Login
                  </Button>
                </Form.Item>
              </Form>
            </div>
            <div className="d-flex justify-content-between">
              <a onClick={forgetClick} style={{ color: "#293890" }}>
                Forget Password
              </a>
              <Link
                to="/OtpLogin"
                // to={{
                //     pathname: "https://insurance.tridentnets.com/onboard",
                //   }}
                //   target="_blank"
              >
                SignUp
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { PospLogin };
